namespace RioERP.Web.Enums {
    export enum Department {
        TechnicalSupport = 1,
        OrderandDelivery = 2
    }
    Serenity.Decorators.registerEnumType(Department, 'RioERP.Web.Enums.Department');
}
